// Stored table copy remains untouched; make overflowing wrappers keyboard usable.
(() => {
  function enhanceTables(root) {
    root.querySelectorAll('.ofl-tool-prose .chapter__table').forEach((wrapper) => {
      if (wrapper.dataset.scrollEnhanced) return;
      wrapper.dataset.scrollEnhanced = 'true';
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      const heading = wrapper.closest('.chapter')?.querySelector('h2');
      if (heading) wrapper.setAttribute('aria-label', heading.textContent.trim());
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceTables(document), { once: true });
  } else {
    enhanceTables(document);
  }
  document.addEventListener('shopify:section:load', (event) => enhanceTables(event.target));
})();
